
class NoneSpatialTipWare {
    constructor(options) {
        this.options = options;
        this.container = null;
        this.idContainer = {};
    }

    addPopup(opts) {
        return new Promise((resolve,reject) => {
            this.removePopup(opts.id);
            const dom = document.createElement('div');
            dom.setAttribute('id', opts.id + '-container');
            dom.setAttribute('class',opts.className);
            dom.innerHTML = `<div id="${opts.id}"></div>`;
            this._getContainer().appendChild(dom);
            this.idContainer[opts.id] = dom;
            resolve({
                id: opts.id,
                containerId: opts.id,
            });
        });
    }

    removePopup(id) {
        const dom = this.idContainer[id];
        if (dom) {
            this._getContainer().removeChild(dom);
        }
        delete this.idContainer[id];
    }

    clearPopup() {
        for (let id in this.idContainer) {
            this.removePopup(id);
        }
    }

    _getContainer() {
        if (!this.container) {
            let container = document.getElementById(this.options.containerId);
            if (!container) {
                container = document.createElement('div');
                container.setAttribute('id', this.options.containerId);
                container.setAttribute('class', this.options.containerClassName);
                document.getElementById(this.options.map.options.targetId).appendChild(container);
            }
            this.container = container;
        }
        return this.container;
    }
};
module.exports = NoneSpatialTipWare;